import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CompareState {
  compareList: string[];
  addToCompare: (id: string) => void;
  toggleCompare: (id: string) => void;
  removeFromCompare: (id: string) => void;
  clearCompare: () => void;
  isInCompare: (id: string) => boolean;
}

export const useCompareStore = create<CompareState>()(
  persist(
    (set, get) => ({
      compareList: [],
      addToCompare: (id) =>
        set((state) => {
          if (state.compareList.length >= 4 || state.compareList.includes(id)) return state;
          return { compareList: [...state.compareList, id] };
        }),
      toggleCompare: (id) =>
        set((state) => {
          if (state.compareList.includes(id)) {
            return { compareList: state.compareList.filter((item) => item !== id) };
          }
          if (state.compareList.length >= 4) return state;
          return { compareList: [...state.compareList, id] };
        }),
      removeFromCompare: (id) =>
        set((state) => ({ compareList: state.compareList.filter((item) => item !== id) })),
      clearCompare: () => set({ compareList: [] }),
      isInCompare: (id) => get().compareList.includes(id),
    }),
    {
      name: 'vivatis-compare',
      version: 1,
      migrate: (persisted, version) => {
        if (version === 0 && Array.isArray(persisted)) {
          return { compareList: persisted };
        }
        return persisted as CompareState;
      },
    },
  ),
);
